import React from "react";

const EconomyBar = ({ savings, stockValue, total }) => {
  const savingsPercent = total === 0 ? 0 : (savings / total) * 100;
  const stockPercent = 100 - savingsPercent;

  return (
    <div style={{ width: 220 }}>
      <div style={{
        display: "flex",
        height: 20,
        border: "1px solid #aaa",
        width: "100%",
        background: "#fff",
        overflow: "hidden"
      }}>
        <div style={{
          width: `${savingsPercent}%`,
          background: "#fff"
        }} />
        <div style={{
          width: `${stockPercent}%`,
          background: "green"
        }} />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12 }}>
        <span style={{ color: "#222" }}>savings</span>
        <span style={{ color: "green" }}>stock</span>
      </div>
      <div style={{ textAlign: "right", fontWeight: "bold", fontSize: 18, color: "#222" }}>
        ${total.toFixed(2)}
      </div>
    </div>
  );
};

export default EconomyBar;